export const BASE_PATH = "customer/loyalty/v1/";
